(function($) {

	$("#c-search-click").click(function(){

		$(".c-search").toggleClass("open");
		$(".c-search .ui-autocomplete-input").focus();

	});

	$(".c-search__close").click(function(){

		$(".c-search").removeClass("open");

	});



})(jQuery);
